import { FC, useMemo } from 'react';
import { Point3D } from '../../types/sagittalTypes';
import { Html } from '@react-three/drei';
import { DEG2RAD } from 'three/src/math/MathUtils';
import { Euler } from 'three';
import { useLabelHighlighter } from '../ui/useHighlighter';
import { ThemeProvider } from '@emotion/react';
import { mainTheme } from '../../../../theme/mainTheme';

interface ThreeDLabelProps {
  position: Point3D;
  label: string;
  visible: boolean;
  plane: 'sagittal' | 'coronal';
  divPosition?: {
    top?: number;
    left?: number;
    right?: number;
    bottom?: number;
  };
  layerKey: string;
}

export const ThreeDLabel: FC<ThreeDLabelProps> = ({
  position,
  label,
  visible,
  divPosition,
  plane,
  layerKey,
}) => {
  const { styles } = useLabelHighlighter({ layerKey });

  const rotation = useMemo(() => {
    if (plane === 'sagittal') {
      return new Euler(0, -90 * DEG2RAD, 0);
    }

    if (plane === 'coronal') {
      return new Euler(0, 0, 0);
    }
  }, [plane]);

  if (!visible) {
    return null;
  }

  return (
    <Html
      position={position}
      scale={0.1}
      rotation={rotation}
      transform
      zIndexRange={[0, 1]}
    >
      <ThemeProvider theme={mainTheme}>
        <div
          style={{
            position: 'absolute',
            padding: '3px',
            borderRadius: '3px',
            ...styles,
            ...divPosition,
            whiteSpace: 'nowrap',
          }}
        >
          {label}
        </div>
      </ThemeProvider>
    </Html>
  );
};
